export default __webpack_public_path__ + "static/media/closeBlackButton.a8348612.svg";